(function ($) {
  'use strict';

  $(document).ready(function () {
    // slick's responsive 'unslick' is one-way — it destroys the resize
    // handler that would re-init, so toggle on matchMedia instead.
    const mobileQuery = window.matchMedia('(width < 768px)');

    // adaptiveHeight locks slick-list to the slide height measured at init, and
    // it only re-measures on slide change. Covers and webfonts are still
    // loading at that point, so the first slide gets clipped — remeasure once
    // everything has settled.
    function remeasure() {
      $('.js-overview-slider.slick-initialized').slick('setPosition');
    }

    function syncSlider() {
      const $sliders = $('.js-overview-slider');

      if (mobileQuery.matches) {
        $sliders.not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          infinite: false,
        });
        remeasure();
        return;
      }

      $sliders.filter('.slick-initialized').slick('unslick');
    }

    syncSlider();
    mobileQuery.addEventListener('change', syncSlider);

    $(window).on('load', remeasure);

    $('.js-overview-slider').find('img').each(function () {
      if (this.complete) {
        return;
      }

      $(this).one('load error', remeasure);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remeasure);
    }
  });
}(jQuery));
